/**
 * Action kind: whatsapp — enquiry instead of checkout.
 *
 * For items sold by conversation (made-to-order, bespoke, price-on-request)
 * rather than through the cart. Chosen per block, not per product: it is an
 * editorial decision about a placement, and it needs no per-item data.
 *
 * The number and message template come from Website HQ Settings and reach the
 * card through the render context, so nothing here knows how they are stored.
 */

import { el, svg } from '../../dom.js';

const WHATSAPP =
	'<path d="M21 11.5a8.5 8.5 0 0 1-12.4 7.55L3 20l1.05-5.4A8.5 8.5 0 1 1 21 11.5z"/>' +
	'<path d="M8.5 9.5c.5 3 2.5 5 5.5 5.5"/>';

export function render(model, ctx) {
	const number = String((ctx && ctx.whatsappNumber) || '').replace(/[^0-9]/g, '');
	// No number configured means no way to enquire — render nothing rather
	// than a button that opens a broken wa.me link.
	if (!number) return null;

	const template = (ctx && ctx.whatsappMessage) || 'Hi, I would like to know more about';
	// encodeURIComponent, not URLSearchParams: the latter encodes spaces as
	// '+', which WhatsApp does accept but its own documentation writes as %20.
	const text = encodeURIComponent(`${template} ${model.title}`.trim());
	const href = `https://wa.me/${number}?text=${text}`;

	return el(
		'a',
		{
			href,
			class: 'btn btn-sm w-100 mt-2 rfhq-pc-cta rfhq-pc-cta--whatsapp',
			target: '_blank',
			rel: 'noopener',
		},
		[svg(WHATSAPP, { class: 'rfhq-pc-cta__icon' }), ' ', model.actions.label || 'Enquire on WhatsApp']
	);
}
